.MessageContainer
    font-size: 14px
    width: 100%
    margin: 0
    padding: 0 20px
    box-sizing: border-box
    *
        margin: 0

@media #{$tablet}
    .MessageContainer
        padding: 0 30px
